import { Session, SessionStatus } from '~/types/tutoring-api'
import { formatAsDay } from '~/utils/time'
import { sortBy } from '~/utils'
import { useGetSessionsListQuery } from '~/redux/apis/session-api'

export default function useGetCompletedSessions(): Session[] | undefined {
  const { data } = useGetSessionsListQuery({
    page: 0,
    range: 20,
    from: formatAsDay(new Date(1970, 0, 1)),
  })

  const completedSessions = data?.filter((elem) => {
    return elem.status === SessionStatus.COMPLETED
  })

  if (completedSessions) {
    return [...sortBy(completedSessions, (elem) => elem.startTime)].reverse() // eslint-disable-line fp/no-mutating-methods
  }
}
